import axios from 'axios';
import { useLoginStore } from '../store/useLogin';

// Axios 인스턴스 생성
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 60000, // 요청 제한 시간 설정
});

// 토큰 만료 여부 확인 함수
export const isTokenExpired = () => {
  const token = localStorage.getItem('token');
  if (!token) return true;
  try {
    // JWT 유효성 검증
    if (!/^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/.test(token)) {
      console.error('Invalid JWT format');
      return true;
    }

    // Base64url → Base64 변환
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      '='
    );

    // 디코딩 후 JSON 파싱
    const decoded = JSON.parse(atob(padded));

    // 현재 시간과 만료 시간 비교
    const currentTime = Math.floor(Date.now() / 1000); // 현재 시간을 초 단위로 변환
    return decoded.exp < currentTime; // 만료 여부 반환
  } catch (error) {
    return true; // 에러 발생 시 토큰을 만료된 것으로 간주
  }
};

// 세션 만료 처리 함수
const handleSessionExpired = () => {
  const { tokenExpire } = useLoginStore.getState();
  tokenExpire();
};

// 요청 인터셉터 설정 (Bearer Token을 자동으로 헤더에 추가)
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token'); // 토큰을 로컬 스토리지 또는 다른 저장소에서 가져오기

    // 요청 URL이 /login인 경우, 토큰 만료 검사 하지 않음
    if (config.url === '/login' || config.url === '/customer/trk-join' || config.url === '/customer/join-franchise') {
      return config;
    }

    // 토큰이 없거나 만료된 경우
    if (!token || isTokenExpired()) {
      handleSessionExpired();
      return Promise.reject('Session expired');
    }

    // 토큰을 헤더에 추가
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터 설정 (응답을 처리하거나 에러를 핸들링)
apiClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 403) {
      // 토큰 만료 또는 인증 실패 시
      handleSessionExpired(); // 세션 만료 처리
    }
    return Promise.reject(error);
  }
);

export default apiClient;
